module.exports = __webpack_public_path__ + "img/sintesis.57487654.svg";